var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showChart)?_c('Chart',{attrs:{"cdata":_vm.cdata}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }